<template>
  <div
    class="my"
    @touchmove="getScrollTop"
  >
    <user></user>
    <!-- <button @click="go">diz</button>
    <button @click="goorder">order</button>
    <button @click="gocol">collect</button> -->
    <van-tabbar
      active-color="#950f0f"
      route
    >
      <van-tabbar-item
        to="/"
        info=""
      >
        <span style="font-size:0.32rem">首页</span>

        <img
          slot="icon"
          src="../assets/footbar/2-02.png"
          style="width:0.55rem;height:0.55rem"
        />
      </van-tabbar-item>
      <van-tabbar-item
        to="/class"
        info=""
      >
        <span style="font-size:0.32rem">产品分类</span>
        <img
          slot="icon"
          src="../assets/footbar/3-02.png"
          style="width:0.55rem;height:0.55rem"
        />
      </van-tabbar-item>
      <van-tabbar-item
        to="/manufactures"
        info=""
      >
        <span style="font-size:0.32rem">厂家直发</span>
        <img
          slot="icon"
          src="../assets/footbar/4-02.png"
          style="width:0.65rem;height:0.55rem"
        />
      </van-tabbar-item>
      <van-tabbar-item
        to="/car"
        info=""
      >
        <span style="font-size:0.32rem">购物车</span>
        <img
          slot="icon"
          src="../assets/footbar/5-02.png"
          style="width:0.6rem;height:0.55rem"
        />
      </van-tabbar-item>
      <van-tabbar-item
        to="/my"
        info=""
      >
        <span style="font-size:0.32rem">我的</span>
        <img
          slot="icon"
          src="../assets/footbar/11-02.png"
          style="width:0.6rem;height:0.55rem"
        />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import Vue from 'vue'
import User from '../components/my/user'
import {
  Search,
  Tab,
  Tabs,
  Icon,
  Tabbar,
  TabbarItem,
  Checkbox,
  CheckboxGroup,
  Button,
  PullRefresh
} from 'vant'
Vue.use(Search)
  .use(Tab)
  .use(Tabs)
  .use(Icon)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Button).use(PullRefresh)
export default {
  created () {

  },
  data () {
    return {
      result: [],
      count: 0,
      isLoading: false,
    }
  },
  methods: {
    getScrollTop () {
      let scrollTop = 0 //滚动高度
      let checkScrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight) //页面总高度
      let getClientHeight = document.documentElement.clientHeight //可视高度
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop
      } else if (document.body) {
        scrollTop = document.body.scrollTop
      }
      let check = checkScrollHeight - scrollTop - getClientHeight
      if (check <= 50) {
        console.log(1)
      }
    },
    checkAll () {
      this.$refs.checkboxGroup.toggleAll(true)
      console.log(this.result)
    },
    toggleAll () {
      this.$refs.checkboxGroup.toggleAll()
    },
    cs (e) {
      // console.log(e)
      // console.log(this.result)
    },
    sd (e) {
      console.log(e)
    },
    onRefresh () {
      setTimeout(() => {
        Toast('刷新成功');
        this.isLoading = false;
        this.count++;
      }, 1000);
    },
    go () {
      this.$router.push('address')
    },
    gocol () {
      this.$router.push('collect')
    },
    goorder () {
      this.$router.push('orderList')
    }
  },
  components: {
    User
  }
}
</script>
<style scoped>
.my {
  height: 100%;
  width: 100%;
  background-color: #f5f5f5;
}
</style>
